export { default } from './ApplyStart.component';
